module.exports = "<div style=\"margin: 10px;\" >\r\n<h4><b><p>Privacy Policy coming soon…</p></b></h4>\r\n\r\n</div>"